import { Component, Input, Output, EventEmitter } from '@angular/core';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'app-checkbox',
  templateUrl: './checkbox.component.html',
  styleUrls: ['./checkbox.component.scss'],
})
export class CheckboxComponent {
  @Input() value: boolean = false;
  @Input() disabled: boolean = false;
  @Input() checkControl: FormControl = new FormControl(null);
  @Input() checkId: string | null = null;

  @Output() checked: EventEmitter<boolean> = new EventEmitter();

  isChecked(event: any) {
    this.checked.emit(event.target.checked);
  }
}
